module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_UAE.971a7360.txt";